import * as APIClient from './APIClient';

export const TYPE_EXPERIMENT_VIEWED = 'experiment_viewed';

export const post = async breadcrumb => {
  const response = await APIClient.post('/v1/breadcrumbs/', breadcrumb);
  return response.json();
};
